import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { SelectOption } from '../model/selectOption'
import {
  CustomEnumCode,
  findCustomEnumValues,
} from '../../infrastructure/api/custom-enums'
import { addGlobalMessage, MessageLevel } from '../../store/messages'

// 呼び出し側は選択肢がカスタム列挙で管理されていることを知る必要がないため、
// コードを指定する形は公開せず、項目ごとのフックとして公開する。
// 選択肢が引けなくても他の項目は編集できるため、取得失敗は再throwせず空で返す。
const useCustomEnumSelectOptions = (
  customEnumCode: CustomEnumCode
): SelectOption[] => {
  const [options, setOptions] = useState<SelectOption[]>([])
  const intl = useIntl()
  const dispatch = useDispatch()

  useEffect(() => {
    let isCancelled = false
    findCustomEnumValues(customEnumCode)
      .then(values => {
        if (isCancelled || !values) return
        setOptions(values)
      })
      .catch(error => {
        if (isCancelled) return
        console.warn(`Failed to fetch ${customEnumCode} select options.`, error)
        // 非2xx応答は共通APIクライアントの経路ではスナックバー通知が出ないため、
        // 選択肢が空のままになる理由をここで知らせる。
        dispatch(
          addGlobalMessage({
            type: MessageLevel.WARN,
            title: intl.formatMessage({ id: 'customEnum.fetchError' }),
          })
        )
      })
    return () => {
      isCancelled = true
    }
  }, [customEnumCode, dispatch, intl])

  return options
}

export const useTimezoneOptions = (): SelectOption[] =>
  useCustomEnumSelectOptions('TIMEZONE')

export const useRegistrationStatusOptions = (): SelectOption[] =>
  useCustomEnumSelectOptions('REGISTRATION_STATUS')

export const useFinancialYearEndMonthOptions = (): SelectOption[] =>
  useCustomEnumSelectOptions('MONTH')
